import DataView from './Data.view';
export * from './Data.view';

export const Data = (props) => DataView(props);

export default Data;

